var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50014 14H18.6359C19.6487 14 20.1551 14 20.5582 13.8112C20.9134 13.6448 21.2118 13.3777 21.4163 13.0432C21.6485 12.6633 21.7044 12.16 21.8163 11.1534L22.4013 5.88835C22.4355 5.58088 22.4525 5.42715 22.4031 5.30816C22.3597 5.20366 22.2821 5.11697 22.183 5.06228C22.0702 5 21.9155 5 21.6062 5H5.00014M2.5 2H3.74844C4.01306 2 4.14537 2 4.24889 2.05032C4.34002 2.09463 4.41554 2.16557 4.46544 2.25376C4.52212 2.35394 4.53037 2.48599 4.54688 2.7501L5.45312 17.2499C5.46963 17.514 5.47788 17.6461 5.53456 17.7462C5.58446 17.8344 5.65998 17.9054 5.75111 17.9497C5.85463 18 5.98694 18 6.25156 18H19.5M8 21.5H8.01M17 21.5H17.01M8.5 21.5C8.5 21.7761 8.27614 22 8 22C7.72386 22 7.5 21.7761 7.5 21.5C7.5 21.2239 7.72386 21 8 21C8.27614 21 8.5 21.2239 8.5 21.5ZM17.5 21.5C17.5 21.7761 17.2761 22 17 22C16.7239 22 16.5 21.7761 16.5 21.5C16.5 21.2239 16.7239 21 17 21C17.2761 21 17.5 21.2239 17.5 21.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.ebea095ab7a2d926dd7ace2809e96142.svg";
export { ForwardRef as ReactComponent };